import { useCallback } from 'react';
import { FORM_MODES } from 'config/formModes';
import { useNavigate } from 'hooks';
import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';
import { LANDING_PAGE_EDITOR_ROUTE_PATH } from '../config';
import { generateFormPath } from '../utils/generateFormPath';

export const useOpenEditDrawer = () => {
    const navigate = useNavigate();
    const { accountId } = useAccount();

    return useCallback(
        landingPage => {
            navigate(
                generateFormPath({
                    accountId,
                    landingPageId: landingPage?.id,
                    mode: FORM_MODES.EDIT,
                    basePath: LANDING_PAGE_EDITOR_ROUTE_PATH,
                })
            );
        },
        [accountId, navigate]
    );
};
